export class BankingReferenceTable {
    code: number;
    name: string;
    phone: string;
    relationshipType: string;
    status?: boolean;
    constructor() {
        this.code = 0;
        this.name = "";
        this.phone = "";
        this.relationshipType = "";
    }
}